import { isTextNode } from 'anodum';

const isEmptyTextNode = (node) => isTextNode(node) && !node.data.length;

export default isEmptyTextNode;
